export default {
	agent_gateway_invalid_chat_input: 'Die Agent-Anfrage ist unvollständig.',
	agent_gateway_provider_capability_unsupported: 'Der Provider unterstützt diese Agent-Anfrage nicht.',
	agent_gateway_provider_chat_failed: 'Der Provider konnte die Agent-Anfrage nicht beantworten.',
	agent_gateway_provider_explorer_structured_output_unsupported: 'Der Explorer benötigt strukturierte Ausgabe.',
	agent_gateway_provider_explorer_tool_use_unsupported: 'Der Explorer benötigt Werkzeugnutzung.',
	agent_gateway_provider_memory_metadata_frontier_denied:
		'Speicher-Metadaten dürfen nicht an Frontier-Provider gesendet werden.',
	agent_gateway_provider_memory_requires_exact_local:
		'Diese Speicheranfrage benötigt einen lokalen Provider ohne Fallback.',
	agent_gateway_provider_memory_summary_frontier_denied:
		'Speicher-Zusammenfassungen dürfen nicht an Frontier-Provider gesendet werden.',
	agent_gateway_provider_preparer_structured_output_unsupported: 'Der Preparer benötigt strukturierte Ausgabe.',
	agent_gateway_provider_structured_output_unsupported: 'Der Provider unterstützt keine strukturierte Ausgabe.',
	agent_gateway_provider_tier_conflict: 'Die Tier-Zuordnung ist nicht eindeutig.',
	agent_gateway_provider_tier_frontier_duplicate: 'Es gibt mehr als einen aktiven Frontier-Provider.',
	agent_gateway_provider_tier_frontier_unavailable: 'Es ist kein Frontier-Provider verfügbar.',
	agent_gateway_provider_tier_local_duplicate: 'Es gibt mehr als einen aktiven lokalen Provider.',
	agent_gateway_provider_tier_local_unavailable: 'Es ist kein lokaler Provider verfügbar.',
	agent_gateway_provider_tier_unavailable: 'Für dieses Tier ist kein Provider verfügbar.',
	agent_list_reference_agendaList: 'Termine öffnen',
	agent_list_reference_documentList: 'Dokumente öffnen',
	agent_list_reference_inbox: 'Inbox öffnen',
	agent_list_reference_mailList: 'Mails öffnen',
	agent_list_reference_messageList: 'Mitteilungen öffnen',
	agent_list_reference_noteList: 'Merkzettel öffnen',
	agent_list_reference_phoneCallList: 'Anrufe öffnen',
	agent_list_reference_records: 'Akten öffnen',
	agent_list_reference_taskList: 'Aufgaben öffnen',
	agent_runtime_activity_hide_label: 'Aktivität ausblenden',
	agent_runtime_activity_intent_classified: 'Absicht erkannt',
	agent_runtime_activity_loop_stopped_max_steps: 'Leseschleife gestoppt',
	agent_runtime_activity_loop_stopped_unsupported_tool: 'Nicht unterstütztes Lesewerkzeug abgelehnt',
	agent_runtime_activity_request_cancelled: 'Anfrage abgebrochen',
	agent_runtime_activity_request_failed: 'Anfrage fehlgeschlagen',
	agent_runtime_activity_request_started: 'Anfrage gesendet',
	agent_runtime_activity_response_received: 'Antwort erhalten',
	agent_runtime_activity_show_label: 'Aktivität anzeigen',
	agent_runtime_activity_subagent_completed: 'Spezialist abgeschlossen',
	agent_runtime_activity_subagent_detail_current_work: 'Arbeitsüberblick',
	agent_runtime_activity_subagent_detail_generic: 'Spezialist',
	agent_runtime_activity_subagent_detail_ido_records: 'Akten-Recherche',
	agent_runtime_activity_subagent_detail_memory: 'Speicher-Recherche',
	agent_runtime_activity_subagent_detail_module_detail: 'Detail-Recherche',
	agent_runtime_activity_subagent_detail_module_list: 'Modul-Recherche',
	agent_runtime_activity_subagent_failed: 'Spezialist fehlgeschlagen',
	agent_runtime_activity_subagent_started: 'Spezialist gestartet',
	agent_runtime_activity_synthesis_critical_failure: 'Alle Quellen fehlgeschlagen',
	agent_runtime_activity_synthesis_partial_degradation: 'Einige Quellen eingeschränkt',
	agent_runtime_activity_title: 'Aktivität',
	agent_runtime_activity_tool_call_requested: 'Lesewerkzeug angefragt',
	agent_runtime_activity_tool_detail_app_context: 'App-Kontext',
	agent_runtime_activity_tool_detail_ido_detail: 'Akten-Detail',
	agent_runtime_activity_tool_detail_ido_instances: 'Akten-Instanzen',
	agent_runtime_activity_tool_detail_ido_search: 'Akten-Suche',
	agent_runtime_activity_tool_detail_inbox: 'Inbox',
	agent_runtime_activity_tool_detail_memory_backlinks: 'Memory-Backlinks',
	agent_runtime_activity_tool_detail_memory_links: 'Memory-Links',
	agent_runtime_activity_tool_detail_memory_page: 'Memory-Seite',
	agent_runtime_activity_tool_detail_memory_search: 'Memory-Suche',
	agent_runtime_activity_tool_detail_memory_tag: 'Memory-Tag',
	agent_runtime_activity_tool_detail_module_detail: 'Moduldetail',
	agent_runtime_activity_tool_detail_module_list: 'Modulliste',
	agent_runtime_activity_tool_detail_task_list_all: 'Aufgabenliste (alle)',
	agent_runtime_activity_tool_detail_task_list_mine: 'Aufgabenliste (meine)',
	agent_runtime_activity_tool_detail_task_list_open: 'Aufgabenliste (offen)',
	agent_runtime_activity_tool_detail_work_overview: 'Arbeitsüberblick (Inbox, Aufgaben)',
	agent_runtime_activity_tool_result_returned: 'Lesewerkzeug abgeschlossen',
	agent_runtime_add_context_label: 'Zum Agent-Kontext hinzufügen',
	agent_runtime_clear_label: 'Chat leeren',
	agent_runtime_close_label: 'Schließen',
	agent_runtime_compatibility_notice_body:
		'Dieses Panel kann für Legacy-Flows noch eine temporäre Compatibility-Bridge verwenden. Die Runtime-Wahrheit kommt aus Gateway-Projektionen, nicht aus lokalem Loop- oder Lifecycle-State.',
	agent_runtime_compatibility_notice_title: 'Compatibility-Seam',
	agent_runtime_context_drop_label: 'Element hier ablegen, um es zum Agent-Kontext hinzuzufügen.',
	agent_runtime_context_empty: 'Kein Detailkontext ausgewählt.',
	agent_runtime_context_focus_label: 'Kontext priorisieren',
	agent_runtime_context_loading_failed: 'Der Mail-Kontext konnte nicht vorbereitet werden.',
	agent_runtime_context_open_label: 'Kontext öffnen',
	agent_runtime_context_remove_label: 'Kontext entfernen',
	agent_runtime_context_title: 'Kontext',
	agent_runtime_degradation_critical_label:
		'Alle Recherchequellen sind fehlgeschlagen. Diese Antwort ist unvollständig.',
	agent_runtime_degradation_partial_label:
		'Einige Recherchequellen waren eingeschränkt. Fehlende Details bitte vorsichtig bewerten.',
	agent_runtime_degradation_retry_label: 'Recherche erneut versuchen',
	agent_runtime_empty_messages: 'Stellen Sie eine Frage zur aktuellen Arbeit.',
	agent_runtime_error_dismiss_label: 'Schließen',
	agent_runtime_error_generic: 'Der Agent konnte die Anfrage nicht verarbeiten.',
	agent_runtime_gateway_projection_event_label: 'Letztes Event',
	agent_runtime_gateway_projection_status_completed: 'Abgeschlossen',
	agent_runtime_gateway_projection_status_failed: 'Fehlgeschlagen',
	agent_runtime_gateway_projection_status_label: 'Status',
	agent_runtime_gateway_projection_status_queued: 'Wartend',
	agent_runtime_gateway_projection_status_running: 'Läuft',
	agent_runtime_gateway_projection_thread_label: 'Thread',
	agent_runtime_gateway_projection_title: 'Gateway-Runtime',
	agent_runtime_loop_stopped_max_steps: 'Der Agent wurde nach zu vielen Leseschritten gestoppt.',
	agent_runtime_loop_stopped_unsupported_tool: 'Der Provider hat ein nicht unterstütztes Lesewerkzeug angefragt.',
	agent_runtime_memory_proposal_block_label: 'Blockieren',
	agent_runtime_memory_proposal_discard_label: 'Verwerfen',
	agent_runtime_memory_proposal_open_settings_label: 'In Einstellungen öffnen',
	agent_runtime_memory_proposal_permission_denied:
		'Für Memory-Vorschläge fehlt die Berechtigung zum Verwalten eigener Memory-Seiten.',
	agent_runtime_memory_proposal_save_label: 'Speichern',
	agent_runtime_memory_proposal_status_blocked: 'Blockiert',
	agent_runtime_memory_proposal_status_discarded: 'Verworfen',
	agent_runtime_memory_proposal_status_proposed: 'Vorgeschlagen',
	agent_runtime_memory_proposal_status_saved: 'Gespeichert',
	agent_runtime_model_label: 'Modell',
	agent_runtime_model_settings_label: 'Modell einstellen',
	agent_runtime_no_models: 'Keine Modelle geladen',
	agent_runtime_no_providers: 'Kein nutzbarer Provider verfügbar.',
	agent_runtime_open_label: 'Agent öffnen',
	agent_runtime_prompt_label: 'Nachricht',
	agent_runtime_provider_label: 'Provider',
	agent_runtime_provider_required: 'Wählen Sie zuerst einen Provider aus.',
	agent_runtime_resize_label: 'Agent-Panel-Breite ändern',
	agent_runtime_retry_label: 'Erneut versuchen',
	agent_runtime_send_label: 'Senden',
	agent_runtime_settings_label: 'Agent-Einstellungen',
	agent_runtime_stop_label: 'Stoppen',
	agent_runtime_thread_ido_instance_research: 'Akten-Recherche',
	agent_runtime_thread_ido_sub_orchestrator: 'IDO/Akten-Sub-Orchestrator',
	agent_runtime_thread_memory_researcher: 'Speicher-Recherche',
	agent_runtime_thread_orchestrator: 'Orchestrator',
	agent_runtime_thread_skip_reason_skippedAfterHighConfidenceFinding:
		'Nach Treffer mit hoher Sicherheit übersprungen.',
	agent_runtime_thread_skipped_summary: '{count} weitere Quelle übersprungen | {count} weitere Quellen übersprungen',
	agent_runtime_thread_status_cancelled: 'abgebrochen',
	agent_runtime_thread_status_completed: 'fertig',
	agent_runtime_thread_status_failed: 'fehlgeschlagen',
	agent_runtime_thread_status_queued: 'wartend',
	agent_runtime_thread_status_running: 'läuft',
	agent_runtime_thread_status_skipped: 'übersprungen',
	agent_runtime_thread_subagent: 'Subagent',
	agent_runtime_thread_tree_title: 'Thread-Übersicht',
	agent_runtime_title: 'Agent',
	agent_runtime_working_label: 'Agent arbeitet...',
};
